import { Box, Grid } from "@mui/material";
import ContactsLeaderboard from "./components/ContactsLeaderBoard";
import RecentContactsByWeekWidget from "./components/ContactsByWeekly";

const ContactsDashboard = () => {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }}>
          <ContactsLeaderboard />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <RecentContactsByWeekWidget />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactsDashboard;
